/* eslint-disable import/prefer-default-export */

import { formatGrossSalary } from './stringHelpers';

export const formatNumber = (
  number: string | number,
  subtype?: string,
): string => {
  const locale = 'en-GB';
  const n =
    subtype === 'grossSalary'
      ? formatGrossSalary(String(number))
      : Number(number);

  return n.toLocaleString(locale);
};
